import { Header } from "@datagame/ui";
import styles from "./Step.module.scss";

export interface StepProps {
  step: number;
  isActive: boolean;
}

export const Step = ({ isActive, step }: StepProps) => {
  return (
    <>
      {isActive ? (
        <div className={styles.activeCircle}>
          <div className={styles.innerCircle}>
            <Header variant="h5" className={styles.activeStep}>
              {step}
            </Header>
          </div>
        </div>
      ) : (
        <div className={styles.circle}>
          <Header variant="h5" className={styles.step}>
            {step}
          </Header>
        </div>
      )}

      <div className={styles.seperator}></div>
    </>
  );
};
